import gql from 'graphql-tag'
import BOOKED_APPOINTMENT_QUERY from './bookedAppointmentQuery'

export default gql`
mutation attachPaymentToAppointment(
  $id: ID!
  $token: String!
  $paymentId: String!
  $paymentProvider: String!
  $transactionUrl: String
) {
  savedAppointment: attachPaymentToAppointment(
    id: $id
    token: $token
    paymentId: $paymentId
    paymentProvider: $paymentProvider
    transactionUrl: $transactionUrl
  ) {
    ${BOOKED_APPOINTMENT_QUERY}
  }
}
`
